import Axios from "axios";
import { authorizationHeader } from "./apiUtils";

const routes = {
  base: "/api/wish",
  add: "/api/wish/add"
};

export const getWishItems = async () => {
  const result = await Axios.get(routes.base, {
    headers: authorizationHeader(),
    withCredentials: true
  });
  return result.data;
};

export const addWishItem = async (productId: number) => {
  const result = await Axios.post(
    routes.add, 
    { productId },
    {
      headers: authorizationHeader(),
      withCredentials: true
    }
  );
  return result.data;
};

export const removeWishItem = async (productId: number) => {
  await Axios.delete(`${routes.base}/${productId}`, {
    headers: authorizationHeader(),
    withCredentials: true
  });
};
